import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import GlobalDialogContent from "../GlobalDialogContent";
import { Box, Chip, Paper, Table, TableBody, TableContainer, TableRow } from "@mui/material";
import CommonTableCell from "../../table/CommonTableCell";
import TableHeadList from "../../table/TableHeadList";
import { rupeeAmountDisplay } from "../../../utils/utils";
import { DonorConfig } from "../../../constant/config";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const AgencyDetails = () => {
    const projectData = useSelector((state: RootState) => state.dialog.payload);
    const lang=useSelector((state:RootState)=>state.lang.language)
    const headCells = [
        { id: "srno", label: { English: "Sr No", Hindi: "क्रम संख्या" }, isFilterable: true },
        { id: "agency_user_name", label:  { English: "NGO Name", Hindi: "कार्यान्वयन एजेंसी का नाम" }, isFilterable: false },
        { id: "implimentation", label:{ English: "Mode of Implementation", Hindi: "कार्यान्वयन का तरीका" }, isFilterable: false },
        { id: "allocated_amount", label: { English: "Allocated Amount", Hindi: "आवंटित राशि" }, isFilterable: false },
        { id: "comment ", label: { English: "Comment", Hindi: "टिप्पणी" }, isFilterable: false },
        { id: "status ", label: { English: "Status", Hindi: "स्थिति" }, isFilterable: false },
    ];

    return (
        <GlobalDialogContent
            dialogBody={
                <TableContainer component={Paper}>
                    <Table>
                        <TableHeadList headCells={headCells.map(cell => ({
                            ...cell,
                            label: cell.label[lang],  
                        }))}/>
                        <TableBody>
                            {projectData?.agency_allocations.length > 0 ? (
                                projectData?.agency_allocations.map((project: any, index: number) => {
                                    return (
                                        <TableRow hover sx={{ '&:hover td.tcell': { backgroundColor: '#FDF8EE' } }} key={index}>
                                            <CommonTableCell value={index + 1} />
                                            <CommonTableCell value={project.agency_user_name || '--CSR-Cell--'} />
                                            <CommonTableCell value={DonorConfig[project.implementation]} />
                                            <CommonTableCell style={{ textAlign: 'right' }} value={rupeeAmountDisplay(project.allocated_amount)} />
                                            <CommonTableCell value={(project?.remark).replace(/<[^>]*>/g, '') || ''} />
                                            <CommonTableCell
                                                style={{ textAlign: 'center' }}
                                                value={<Box display="flex" alignItems="center">
                                                    <Chip
                                                        label={project.implementation === 'csr-cell' ? 'Approved' : project?.status?.toLowerCase() === 'pending' && project?.pending_from?.length
                                                            ? 'Pending '
                                                            : project?.status?.charAt(0).toUpperCase() + project?.status?.slice(1).toLowerCase()}
                                                        size="small"
                                                        icon={project.status === 'approved' || project.implementation === 'csr-cell' ? <CheckCircleIcon sx={{ color: 'green' }} /> : project.status === 'rejected' ? <HighlightOffIcon sx={{ color: 'red' }} /> : <HourglassTopIcon sx={{ color: 'red' }} />}
                                                        color={project.status === 'approved' || project.implementation === 'csr-cell' ? 'success' : project.status === 'rejected' ? 'primary' : 'warning'}
                                                        variant="outlined" />
                                                </Box>} />
                                        </TableRow>
                                    );
                                })
                            ) : (
                                <TableRow hover sx={{ '&:hover td.tcell': { backgroundColor: '#FDF8EE' } }}>
                                    <CommonTableCell value="No Data Available" />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            }
        />
    );
};

export default AgencyDetails;
